import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateInitiativeParticipation } from '../../../../modules/initiativeParticipations.js';
import {
  retrieveInitiative,
  retrieveInitiativeAncestry,
} from '../../../../modules/initiatives.js';
import AuthorizedAction from '../../../AuthorizedAction.js';

const mapDispatchToProps = (
  dispatch,
  { initiative, initiativeParticipation }
) =>
  bindActionCreators(
    {
      retrieveInitiative: () =>
        retrieveInitiative(initiative.type, initiative.id),
      retrieveInitiativeAncestry: () =>
        retrieveInitiativeAncestry(initiative.type, initiative.id),
      toggleCompleted: () =>
        updateInitiativeParticipation(initiativeParticipation.id, {
          completed: !initiativeParticipation.completedAt,
        }),
    },
    dispatch
  );

class InitiativeParticipationCompletionButton extends React.PureComponent {
  state = {
    submitting: false,
  };

  refreshInitiative = () => {
    const { retrieveInitiative, retrieveInitiativeAncestry } = this.props;

    return Promise.all([retrieveInitiative(), retrieveInitiativeAncestry()]);
  };

  handleClick = () => {
    const { toggleCompleted } = this.props;

    this.setState({ submitting: true });

    toggleCompleted()
      .then(this.refreshInitiative)
      .then(() => this.setState({ submitting: false }));
  };

  render() {
    const {
      initiativeParticipation: { completedAt },
      isPreview,
      initiative,
    } = this.props;
    const { submitting } = this.state;

    return (
      <span>
        {!isPreview &&
        initiative.project[
          `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
        ] ? (
          <AuthorizedAction
            action="update"
            subject={`${initiative.type}Initiative`}
          >
            <Button
              block
              bsStyle={completedAt ? 'default' : 'primary'}
              disabled={submitting || initiative.project.archived}
              onClick={this.handleClick}
            >
              {completedAt ? 'Completed' : 'Mark Completed'}
            </Button>
          </AuthorizedAction>
        ) : null}
      </span>
    );
  }
}

InitiativeParticipationCompletionButton = connect(
  null,
  mapDispatchToProps
)(InitiativeParticipationCompletionButton);

InitiativeParticipationCompletionButton.propTypes = {
  initiative: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  initiativeParticipation: PropTypes.shape({
    id: PropTypes.number.isRequired,
    completedAt: PropTypes.object,
  }).isRequired,
};

export default InitiativeParticipationCompletionButton;
